import React from 'react';
import { IonApp, IonRouterOutlet, setupIonicReact } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { Redirect, Route } from 'react-router';

//	C S S   D E F A U L T S

import '@ionic/react/css/core.css';
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

//	T H E M E   F O N T S

import './theme/theme.fonts/font-awesome/css/all.min.css';
import './theme/theme.fonts/quicksand/quicksand.css';

//	T H E M E

import './theme/theme.reset.scss';
import './theme/theme.variables.scss';
import './theme/theme.global.scss';
import './theme/theme.mapbox.scss';

//	T Y P E S

import { type___geo___lngLat } from './types/types.types';

//	S T A T E   -   P R O P S

import { state___App, state___App___default } from './App.state';

//	S E R V I C E S

import { service_GeolocationService } from './services/service-geolocation';

//	P A G E S

import SbDiscoverMapPage from './pages/sb-discover-map/sb-discover-map';
import SbLandingPage from './pages/sb-landing/sb-landing';

//	S E T U P

setupIonicReact({ mode: 'ios' });

//	C L A S S

export default class App extends React.Component<{}, state___App> {

//#region 																							D E C L A R A T I O N S

	private _ABORT_CONTROLLER: AbortController | null = null;

	private readonly _GEOLOCATION: service_GeolocationService = new service_GeolocationService();

//#endregion

//#region 																							C O N S T R U C T O R

	constructor(
		public props: {},
	) {
		super(props);
		this.state = state___App___default;
		if (!this._ABORT_CONTROLLER) { this._ABORT_CONTROLLER = new AbortController(); }
	}

//#endregion

//#region 																							A B O R T   C O N T R O L L E R

	private AbortController___abort() : void {
		if (this._ABORT_CONTROLLER) { this._ABORT_CONTROLLER.abort(); }
	}

//#endregion

//#region 																							E N T R Y

	private entry___geolocation = () => {
	/*	(async () => {
			const ___geolocation___result: type___geo___lngLat = await this._GEOLOCATION.geolocation___locate();
			if (___geolocation___result['error'] && ___geolocation___result['error'] !== null) {
				this.setState({
					entry___geolocation_available: false
				});
			} else {
				this.setState({
					entry___geolocation_available: true
				});
			}
		})();*/
	}

//#endregion

//#region 																							L I F E C Y C L E

	async componentDidMount() : Promise<void> {
		this.AbortController___abort();
	//	this.entry___geolocation();
		setTimeout(() => {
			this.setState({
				app___isLoading: false,
				entry___geolocation_available: false
			});
		}, 100);
	}

	componentWillUnmount() : void {
		this.AbortController___abort();
	}

//#endregion

//#region 																							R E N D E R

	render() : React.ReactNode {
		return <>
			<IonApp>
				<IonReactRouter>
					{(this.state.app___isLoading === true || this.state.entry___geolocation_available === null) ? <>
						<SbLandingPage/>
					</> : <>
						<IonRouterOutlet>
							<Route path="/custom/:id" component={(___p: any) => { return <SbDiscoverMapPage {...___p} />}} exact />
							<Route path="/" component={(___p: any) => { return <SbDiscoverMapPage {...___p} />}} exact />
						</IonRouterOutlet>
					</>}
				</IonReactRouter>
			</IonApp>
		</>;
	}

//#endregion

}